import { BRAND_ENUM, SUPPORTED_BRANDS, type Brand } from './brandConstants';

const SUPPORTED_BRAND_SET = new Set<string>(SUPPORTED_BRANDS);

/**
 * Resolve the active brand from `NEXT_PUBLIC_BRAND`.
 *
 * Example Input:
 * process.env.NEXT_PUBLIC_BRAND = 'gallet'
 *
 * Example Output:
 * 'gallet'
 */
export function requireBrand(context = 'build'): Brand {
  const raw = process.env.NEXT_PUBLIC_BRAND?.trim().toLowerCase();

  if (!raw) {
    throw new Error(
      `NEXT_PUBLIC_BRAND is required for ${context}. ` +
        `Set it to one of: ${SUPPORTED_BRANDS.join(', ')}. ` +
        `Example: NEXT_PUBLIC_BRAND=gallet pnpm dev`
    );
  }

  if (!SUPPORTED_BRAND_SET.has(raw)) {
    throw new Error(
      `NEXT_PUBLIC_BRAND="${process.env.NEXT_PUBLIC_BRAND}" is invalid for ${context}. ` +
        `Must be one of: ${SUPPORTED_BRANDS.join(', ')}.`
    );
  }

  return raw as Brand;
}

export { BRAND_ENUM };
